import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition } from './../wayfinder'
/**
* @see \App\Http\Controllers\LoginController::login
* @see app/Http/Controllers/LoginController.php:19
* @route '/login'
*/
export const login = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: login.url(options),
    method: 'get',
})

login.definition = {
    methods: ["get","head"],
    url: '/login',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\LoginController::login
* @see app/Http/Controllers/LoginController.php:19
* @route '/login'
*/
login.url = (options?: RouteQueryOptions) => {
    return login.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\LoginController::login
* @see app/Http/Controllers/LoginController.php:19
* @route '/login'
*/
login.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: login.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\LoginController::login
* @see app/Http/Controllers/LoginController.php:19
* @route '/login'
*/
login.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: login.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\LoginController::login
* @see app/Http/Controllers/LoginController.php:19
* @route '/login'
*/
const loginForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: login.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\LoginController::login
* @see app/Http/Controllers/LoginController.php:19
* @route '/login'
*/
loginForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: login.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\LoginController::login
* @see app/Http/Controllers/LoginController.php:19
* @route '/login'
*/
loginForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: login.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

login.form = loginForm

/**
* @see \Laravel\Fortify\Http\Controllers\AuthenticatedSessionController::logout
* @see vendor/laravel/fortify/src/Http/Controllers/AuthenticatedSessionController.php:100
* @route '/logout'
*/
export const logout = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: logout.url(options),
    method: 'post',
})

logout.definition = {
    methods: ["post"],
    url: '/logout',
} satisfies RouteDefinition<["post"]>

/**
* @see \Laravel\Fortify\Http\Controllers\AuthenticatedSessionController::logout
* @see vendor/laravel/fortify/src/Http/Controllers/AuthenticatedSessionController.php:100
* @route '/logout'
*/
logout.url = (options?: RouteQueryOptions) => {
    return logout.definition.url + queryParams(options)
}

/**
* @see \Laravel\Fortify\Http\Controllers\AuthenticatedSessionController::logout
* @see vendor/laravel/fortify/src/Http/Controllers/AuthenticatedSessionController.php:100
* @route '/logout'
*/
logout.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: logout.url(options),
    method: 'post',
})

/**
* @see \Laravel\Fortify\Http\Controllers\AuthenticatedSessionController::logout
* @see vendor/laravel/fortify/src/Http/Controllers/AuthenticatedSessionController.php:100
* @route '/logout'
*/
const logoutForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: logout.url(options),
    method: 'post',
})

/**
* @see \Laravel\Fortify\Http\Controllers\AuthenticatedSessionController::logout
* @see vendor/laravel/fortify/src/Http/Controllers/AuthenticatedSessionController.php:100
* @route '/logout'
*/
logoutForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: logout.url(options),
    method: 'post',
})

logout.form = logoutForm

/**
* @see \Laravel\Fortify\Http\Controllers\RegisteredUserController::register
* @see vendor/laravel/fortify/src/Http/Controllers/RegisteredUserController.php:41
* @route '/register'
*/
export const register = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: register.url(options),
    method: 'get',
})

register.definition = {
    methods: ["get","head"],
    url: '/register',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \Laravel\Fortify\Http\Controllers\RegisteredUserController::register
* @see vendor/laravel/fortify/src/Http/Controllers/RegisteredUserController.php:41
* @route '/register'
*/
register.url = (options?: RouteQueryOptions) => {
    return register.definition.url + queryParams(options)
}

/**
* @see \Laravel\Fortify\Http\Controllers\RegisteredUserController::register
* @see vendor/laravel/fortify/src/Http/Controllers/RegisteredUserController.php:41
* @route '/register'
*/
register.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: register.url(options),
    method: 'get',
})

/**
* @see \Laravel\Fortify\Http\Controllers\RegisteredUserController::register
* @see vendor/laravel/fortify/src/Http/Controllers/RegisteredUserController.php:41
* @route '/register'
*/
register.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: register.url(options),
    method: 'head',
})

/**
* @see \Laravel\Fortify\Http\Controllers\RegisteredUserController::register
* @see vendor/laravel/fortify/src/Http/Controllers/RegisteredUserController.php:41
* @route '/register'
*/
const registerForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: register.url(options),
    method: 'get',
})

/**
* @see \Laravel\Fortify\Http\Controllers\RegisteredUserController::register
* @see vendor/laravel/fortify/src/Http/Controllers/RegisteredUserController.php:41
* @route '/register'
*/
registerForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: register.url(options),
    method: 'get',
})

/**
* @see \Laravel\Fortify\Http\Controllers\RegisteredUserController::register
* @see vendor/laravel/fortify/src/Http/Controllers/RegisteredUserController.php:41
* @route '/register'
*/
registerForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: register.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

register.form = registerForm

/**
* @see routes/web.php:24
* @route '/sw.js'
*/
export const pwaSw = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: pwaSw.url(options),
    method: 'get',
})

pwaSw.definition = {
    methods: ["get","head"],
    url: '/sw.js',
} satisfies RouteDefinition<["get","head"]>

/**
* @see routes/web.php:24
* @route '/sw.js'
*/
pwaSw.url = (options?: RouteQueryOptions) => {
    return pwaSw.definition.url + queryParams(options)
}

/**
* @see routes/web.php:24
* @route '/sw.js'
*/
pwaSw.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: pwaSw.url(options),
    method: 'get',
})

/**
* @see routes/web.php:24
* @route '/sw.js'
*/
pwaSw.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: pwaSw.url(options),
    method: 'head',
})

/**
* @see routes/web.php:24
* @route '/sw.js'
*/
const pwaSwForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: pwaSw.url(options),
    method: 'get',
})

/**
* @see routes/web.php:24
* @route '/sw.js'
*/
pwaSwForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: pwaSw.url(options),
    method: 'get',
})

/**
* @see routes/web.php:24
* @route '/sw.js'
*/
pwaSwForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: pwaSw.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

pwaSw.form = pwaSwForm

/**
* @see routes/web.php:48
* @route '/apple-touch-icon.png'
*/
export const appleTouchIcon = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: appleTouchIcon.url(options),
    method: 'get',
})

appleTouchIcon.definition = {
    methods: ["get","head"],
    url: '/apple-touch-icon.png',
} satisfies RouteDefinition<["get","head"]>

/**
* @see routes/web.php:48
* @route '/apple-touch-icon.png'
*/
appleTouchIcon.url = (options?: RouteQueryOptions) => {
    return appleTouchIcon.definition.url + queryParams(options)
}

/**
* @see routes/web.php:48
* @route '/apple-touch-icon.png'
*/
appleTouchIcon.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: appleTouchIcon.url(options),
    method: 'get',
})

/**
* @see routes/web.php:48
* @route '/apple-touch-icon.png'
*/
appleTouchIcon.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: appleTouchIcon.url(options),
    method: 'head',
})

/**
* @see routes/web.php:48
* @route '/apple-touch-icon.png'
*/
const appleTouchIconForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: appleTouchIcon.url(options),
    method: 'get',
})

/**
* @see routes/web.php:48
* @route '/apple-touch-icon.png'
*/
appleTouchIconForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: appleTouchIcon.url(options),
    method: 'get',
})

/**
* @see routes/web.php:48
* @route '/apple-touch-icon.png'
*/
appleTouchIconForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: appleTouchIcon.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

appleTouchIcon.form = appleTouchIconForm

/**
* @see routes/web.php:64
* @route '/manifest.json'
*/
export const manifest = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: manifest.url(options),
    method: 'get',
})

manifest.definition = {
    methods: ["get","head"],
    url: '/manifest.json',
} satisfies RouteDefinition<["get","head"]>

/**
* @see routes/web.php:64
* @route '/manifest.json'
*/
manifest.url = (options?: RouteQueryOptions) => {
    return manifest.definition.url + queryParams(options)
}

/**
* @see routes/web.php:64
* @route '/manifest.json'
*/
manifest.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: manifest.url(options),
    method: 'get',
})

/**
* @see routes/web.php:64
* @route '/manifest.json'
*/
manifest.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: manifest.url(options),
    method: 'head',
})

/**
* @see routes/web.php:64
* @route '/manifest.json'
*/
const manifestForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: manifest.url(options),
    method: 'get',
})

/**
* @see routes/web.php:64
* @route '/manifest.json'
*/
manifestForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: manifest.url(options),
    method: 'get',
})

/**
* @see routes/web.php:64
* @route '/manifest.json'
*/
manifestForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: manifest.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

manifest.form = manifestForm

/**
* @see routes/web.php:198
* @route '/.well-known/assetlinks.json'
*/
export const assetlinks = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: assetlinks.url(options),
    method: 'get',
})

assetlinks.definition = {
    methods: ["get","head"],
    url: '/.well-known/assetlinks.json',
} satisfies RouteDefinition<["get","head"]>

/**
* @see routes/web.php:198
* @route '/.well-known/assetlinks.json'
*/
assetlinks.url = (options?: RouteQueryOptions) => {
    return assetlinks.definition.url + queryParams(options)
}

/**
* @see routes/web.php:198
* @route '/.well-known/assetlinks.json'
*/
assetlinks.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: assetlinks.url(options),
    method: 'get',
})

/**
* @see routes/web.php:198
* @route '/.well-known/assetlinks.json'
*/
assetlinks.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: assetlinks.url(options),
    method: 'head',
})

/**
* @see routes/web.php:198
* @route '/.well-known/assetlinks.json'
*/
const assetlinksForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: assetlinks.url(options),
    method: 'get',
})

/**
* @see routes/web.php:198
* @route '/.well-known/assetlinks.json'
*/
assetlinksForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: assetlinks.url(options),
    method: 'get',
})

/**
* @see routes/web.php:198
* @route '/.well-known/assetlinks.json'
*/
assetlinksForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: assetlinks.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

assetlinks.form = assetlinksForm

/**
* @see routes/web.php:223
* @route '/offline'
*/
export const offline = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: offline.url(options),
    method: 'get',
})

offline.definition = {
    methods: ["get","head"],
    url: '/offline',
} satisfies RouteDefinition<["get","head"]>

/**
* @see routes/web.php:223
* @route '/offline'
*/
offline.url = (options?: RouteQueryOptions) => {
    return offline.definition.url + queryParams(options)
}

/**
* @see routes/web.php:223
* @route '/offline'
*/
offline.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: offline.url(options),
    method: 'get',
})

/**
* @see routes/web.php:223
* @route '/offline'
*/
offline.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: offline.url(options),
    method: 'head',
})

/**
* @see routes/web.php:223
* @route '/offline'
*/
const offlineForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: offline.url(options),
    method: 'get',
})

/**
* @see routes/web.php:223
* @route '/offline'
*/
offlineForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: offline.url(options),
    method: 'get',
})

/**
* @see routes/web.php:223
* @route '/offline'
*/
offlineForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: offline.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

offline.form = offlineForm

/**
* @see routes/web.php:232
* @route '/'
*/
export const home = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: home.url(options),
    method: 'get',
})

home.definition = {
    methods: ["get","head"],
    url: '/',
} satisfies RouteDefinition<["get","head"]>

/**
* @see routes/web.php:232
* @route '/'
*/
home.url = (options?: RouteQueryOptions) => {
    return home.definition.url + queryParams(options)
}

/**
* @see routes/web.php:232
* @route '/'
*/
home.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: home.url(options),
    method: 'get',
})

/**
* @see routes/web.php:232
* @route '/'
*/
home.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: home.url(options),
    method: 'head',
})

/**
* @see routes/web.php:232
* @route '/'
*/
const homeForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: home.url(options),
    method: 'get',
})

/**
* @see routes/web.php:232
* @route '/'
*/
homeForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: home.url(options),
    method: 'get',
})

/**
* @see routes/web.php:232
* @route '/'
*/
homeForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: home.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

home.form = homeForm

/**
* @see routes/web.php:238
* @route '/welcome'
*/
export const welcome = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: welcome.url(options),
    method: 'get',
})

welcome.definition = {
    methods: ["get","head"],
    url: '/welcome',
} satisfies RouteDefinition<["get","head"]>

/**
* @see routes/web.php:238
* @route '/welcome'
*/
welcome.url = (options?: RouteQueryOptions) => {
    return welcome.definition.url + queryParams(options)
}

/**
* @see routes/web.php:238
* @route '/welcome'
*/
welcome.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: welcome.url(options),
    method: 'get',
})

/**
* @see routes/web.php:238
* @route '/welcome'
*/
welcome.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: welcome.url(options),
    method: 'head',
})

/**
* @see routes/web.php:238
* @route '/welcome'
*/
const welcomeForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: welcome.url(options),
    method: 'get',
})

/**
* @see routes/web.php:238
* @route '/welcome'
*/
welcomeForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: welcome.url(options),
    method: 'get',
})

/**
* @see routes/web.php:238
* @route '/welcome'
*/
welcomeForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: welcome.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

welcome.form = welcomeForm

/**
* @see routes/web.php:247
* @route '/terms'
*/
export const terms = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: terms.url(options),
    method: 'get',
})

terms.definition = {
    methods: ["get","head"],
    url: '/terms',
} satisfies RouteDefinition<["get","head"]>

/**
* @see routes/web.php:247
* @route '/terms'
*/
terms.url = (options?: RouteQueryOptions) => {
    return terms.definition.url + queryParams(options)
}

/**
* @see routes/web.php:247
* @route '/terms'
*/
terms.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: terms.url(options),
    method: 'get',
})

/**
* @see routes/web.php:247
* @route '/terms'
*/
terms.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: terms.url(options),
    method: 'head',
})

/**
* @see routes/web.php:247
* @route '/terms'
*/
const termsForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: terms.url(options),
    method: 'get',
})

/**
* @see routes/web.php:247
* @route '/terms'
*/
termsForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: terms.url(options),
    method: 'get',
})

/**
* @see routes/web.php:247
* @route '/terms'
*/
termsForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: terms.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

terms.form = termsForm

/**
* @see routes/web.php:250
* @route '/privacy'
*/
export const privacy = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: privacy.url(options),
    method: 'get',
})

privacy.definition = {
    methods: ["get","head"],
    url: '/privacy',
} satisfies RouteDefinition<["get","head"]>

/**
* @see routes/web.php:250
* @route '/privacy'
*/
privacy.url = (options?: RouteQueryOptions) => {
    return privacy.definition.url + queryParams(options)
}

/**
* @see routes/web.php:250
* @route '/privacy'
*/
privacy.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: privacy.url(options),
    method: 'get',
})

/**
* @see routes/web.php:250
* @route '/privacy'
*/
privacy.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: privacy.url(options),
    method: 'head',
})

/**
* @see routes/web.php:250
* @route '/privacy'
*/
const privacyForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: privacy.url(options),
    method: 'get',
})

/**
* @see routes/web.php:250
* @route '/privacy'
*/
privacyForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: privacy.url(options),
    method: 'get',
})

/**
* @see routes/web.php:250
* @route '/privacy'
*/
privacyForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: privacy.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

privacy.form = privacyForm

/**
* @see routes/web.php:269
* @route '/dashboard'
*/
export const dashboard = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: dashboard.url(options),
    method: 'get',
})

dashboard.definition = {
    methods: ["get","head"],
    url: '/dashboard',
} satisfies RouteDefinition<["get","head"]>

/**
* @see routes/web.php:269
* @route '/dashboard'
*/
dashboard.url = (options?: RouteQueryOptions) => {
    return dashboard.definition.url + queryParams(options)
}

/**
* @see routes/web.php:269
* @route '/dashboard'
*/
dashboard.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: dashboard.url(options),
    method: 'get',
})

/**
* @see routes/web.php:269
* @route '/dashboard'
*/
dashboard.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: dashboard.url(options),
    method: 'head',
})

/**
* @see routes/web.php:269
* @route '/dashboard'
*/
const dashboardForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: dashboard.url(options),
    method: 'get',
})

/**
* @see routes/web.php:269
* @route '/dashboard'
*/
dashboardForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: dashboard.url(options),
    method: 'get',
})

/**
* @see routes/web.php:269
* @route '/dashboard'
*/
dashboardForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: dashboard.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

dashboard.form = dashboardForm

/**
* @see \App\Http\Controllers\ProfileController::profile
* @see app/Http/Controllers/ProfileController.php:18
* @route '/profile'
*/
export const profile = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: profile.url(options),
    method: 'get',
})

profile.definition = {
    methods: ["get","head"],
    url: '/profile',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\ProfileController::profile
* @see app/Http/Controllers/ProfileController.php:18
* @route '/profile'
*/
profile.url = (options?: RouteQueryOptions) => {
    return profile.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\ProfileController::profile
* @see app/Http/Controllers/ProfileController.php:18
* @route '/profile'
*/
profile.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: profile.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\ProfileController::profile
* @see app/Http/Controllers/ProfileController.php:18
* @route '/profile'
*/
profile.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: profile.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\ProfileController::profile
* @see app/Http/Controllers/ProfileController.php:18
* @route '/profile'
*/
const profileForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: profile.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\ProfileController::profile
* @see app/Http/Controllers/ProfileController.php:18
* @route '/profile'
*/
profileForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: profile.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\ProfileController::profile
* @see app/Http/Controllers/ProfileController.php:18
* @route '/profile'
*/
profileForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: profile.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

profile.form = profileForm

/**
* @see \App\Http\Controllers\WalletController::wallet
* @see app/Http/Controllers/WalletController.php:29
* @route '/wallet'
*/
export const wallet = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: wallet.url(options),
    method: 'get',
})

wallet.definition = {
    methods: ["get","head"],
    url: '/wallet',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\WalletController::wallet
* @see app/Http/Controllers/WalletController.php:29
* @route '/wallet'
*/
wallet.url = (options?: RouteQueryOptions) => {
    return wallet.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\WalletController::wallet
* @see app/Http/Controllers/WalletController.php:29
* @route '/wallet'
*/
wallet.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: wallet.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\WalletController::wallet
* @see app/Http/Controllers/WalletController.php:29
* @route '/wallet'
*/
wallet.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: wallet.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\WalletController::wallet
* @see app/Http/Controllers/WalletController.php:29
* @route '/wallet'
*/
const walletForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: wallet.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\WalletController::wallet
* @see app/Http/Controllers/WalletController.php:29
* @route '/wallet'
*/
walletForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: wallet.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\WalletController::wallet
* @see app/Http/Controllers/WalletController.php:29
* @route '/wallet'
*/
walletForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: wallet.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

wallet.form = walletForm

/**
* @see routes/web.php:300
* @route '/scan-to-pay'
*/
export const scanToPay = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: scanToPay.url(options),
    method: 'get',
})

scanToPay.definition = {
    methods: ["get","head"],
    url: '/scan-to-pay',
} satisfies RouteDefinition<["get","head"]>

/**
* @see routes/web.php:300
* @route '/scan-to-pay'
*/
scanToPay.url = (options?: RouteQueryOptions) => {
    return scanToPay.definition.url + queryParams(options)
}

/**
* @see routes/web.php:300
* @route '/scan-to-pay'
*/
scanToPay.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: scanToPay.url(options),
    method: 'get',
})

/**
* @see routes/web.php:300
* @route '/scan-to-pay'
*/
scanToPay.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: scanToPay.url(options),
    method: 'head',
})

/**
* @see routes/web.php:300
* @route '/scan-to-pay'
*/
const scanToPayForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: scanToPay.url(options),
    method: 'get',
})

/**
* @see routes/web.php:300
* @route '/scan-to-pay'
*/
scanToPayForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: scanToPay.url(options),
    method: 'get',
})

/**
* @see routes/web.php:300
* @route '/scan-to-pay'
*/
scanToPayForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: scanToPay.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

scanToPay.form = scanToPayForm

/**
* @see routes/web.php:326
* @route '/send-money'
*/
export const sendMoney = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: sendMoney.url(options),
    method: 'get',
})

sendMoney.definition = {
    methods: ["get","head"],
    url: '/send-money',
} satisfies RouteDefinition<["get","head"]>

/**
* @see routes/web.php:326
* @route '/send-money'
*/
sendMoney.url = (options?: RouteQueryOptions) => {
    return sendMoney.definition.url + queryParams(options)
}

/**
* @see routes/web.php:326
* @route '/send-money'
*/
sendMoney.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: sendMoney.url(options),
    method: 'get',
})

/**
* @see routes/web.php:326
* @route '/send-money'
*/
sendMoney.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: sendMoney.url(options),
    method: 'head',
})

/**
* @see routes/web.php:326
* @route '/send-money'
*/
const sendMoneyForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: sendMoney.url(options),
    method: 'get',
})

/**
* @see routes/web.php:326
* @route '/send-money'
*/
sendMoneyForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: sendMoney.url(options),
    method: 'get',
})

/**
* @see routes/web.php:326
* @route '/send-money'
*/
sendMoneyForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: sendMoney.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

sendMoney.form = sendMoneyForm
